import { IndividualBaseViewModel } from "../IndividualViewModel";

// this class is used to hold message dialog service response data and createParent() API response data together
export class AddParentDialogResponseModel{
    parent:IndividualBaseViewModel;
    familyId:number;
    isMemberNavigate?: boolean;
}